import { render, staticRenderFns } from "./carDetailCoupon.vue?vue&type=template&id=252eac57"
import script from "./carDetailCoupon.vue?vue&type=script&lang=js"
export * from "./carDetailCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports